import { AppConfig } from 'AppConfig';

const { domain, apiPath, veevaPath, validateUser } = AppConfig.veevaApi;

const API_URL = `${domain}/${apiPath}`;
const DATA_VEEVA_URL = `${API_URL}/${veevaPath}/${validateUser}`;

export { API_URL, DATA_VEEVA_URL };
